module.exports = __webpack_public_path__ + "img/044-pitchfork.adea544a.png";